var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.getBrandName === 'PARSEQ_NAME')?_c('p',[_vm._v(" PARallele™ "),_vm._t("default")],2):_vm._e(),(_vm.getBrandName === 'EPIVALUE_NAME')?_c('p',[_vm._v(" GeneValue "),_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }